export default function QuotTC() {
  return (
    <table
      border="0"
      cellpadding="50"
      cellspacing="50"
      width="100%"
      style={{ fontSize: "11px" }}
    >
      <tbody>
        <tr style={{ paddingTop: "20px" }}>
          <td
            style={{ fontSize: "14px", width: "300px", paddingTop: "20px" }}
            valign="top"
          >
            <strong>1.&nbsp; Price:</strong>
          </td>
          <td style={{ paddingTop: "20px" }}>
            <p style={{ fontSize: "14px" }}>
              All quoted prices are ex-works New Delhi (India)
            </p>
          </td>
        </tr>
        <tr style={{ paddingTop: "20px" }}>
          <td
            style={{ fontSize: "14px", width: "300px", paddingTop: "20px" }}
            valign="top"
          >
            <strong>2.&nbsp; Inland Handling & Freight:</strong>
          </td>
          <td style={{ paddingTop: "20px" }}>
            <p style={{ fontSize: "14px" }}>Extra as applicable.</p>
          </td>
        </tr>
        <tr style={{ paddingTop: "20px" }}>
          <td
            style={{ fontSize: "14px", width: "300px", paddingTop: "20px" }}
            valign="top"
          >
            <strong>3.&nbsp; Validity:</strong>
          </td>
          <td style={{ paddingTop: "20px" }}>
            <p style={{ fontSize: "14px" }}>
              This offer is valid for a period of 30 days from the date of
              issuance
            </p>
          </td>
        </tr>
        <tr style={{ paddingTop: "20px" }}>
          <td
            style={{ fontSize: "14px", width: "300px", paddingTop: "20px" }}
            valign="top"
          >
            <strong>4.&nbsp; Applicable Taxes:</strong>
          </td>
          <td style={{ paddingTop: "20px" }}>
            <p style={{ fontSize: "14px" }}>GST Extra @18%</p>
          </td>
        </tr>
        <tr style={{ paddingTop: "20px" }}>
          <td
            style={{ fontSize: "14px", width: "300px", paddingTop: "20px" }}
            valign="top"
          >
            <strong>5.&nbsp; Octroi:</strong>
          </td>
          <td style={{ paddingTop: "20px" }}>
            <p style={{ fontSize: "14px" }}>Extra at actuals if applicable</p>
          </td>
        </tr>
        <tr style={{ paddingTop: "20px" }}>
          <td
            style={{ fontSize: "14px", width: "300px", paddingTop: "20px" }}
            valign="top"
          >
            <strong>6.&nbsp; Terms of Payment:</strong>
          </td>
          <td style={{ paddingTop: "20px" }}>
            <p style={{ fontSize: "14px" }}>
              100% advance along with Purchase Order.
            </p>
          </td>
        </tr>
        <tr style={{ paddingTop: "20px" }}>
          <td
            style={{ fontSize: "14px", width: "300px", paddingTop: "20px" }}
            valign="top"
          >
            <strong>7.&nbsp; End-use Statement:</strong>
          </td>
          <td style={{ paddingTop: "20px" }}>
            <p style={{ fontSize: "14px" }}>
              In certain cases, the Original Equipment Manufacturer, to meet its
              statutory obligations, would need from the customer a certificate
              stating the purported use of the ordered product(s). A performa to
              facilitate the same will be provided by us.
            </p>
          </td>
        </tr>
        <tr style={{ paddingTop: "20px" }}>
          <td
            style={{ fontSize: "14px", width: "300px", paddingTop: "20px" }}
            valign="top"
          >
            <strong>8.&nbsp; Delivery:</strong>
          </td>
          <td style={{ paddingTop: "20px" }}>
            <p style={{ fontSize: "14px" }}>
              Within 3 to 4 Weeks from the date of acceptance of confirmed
              Purchase Order along with advance payment.
            </p>
          </td>
        </tr>
        <tr style={{ paddingTop: "20px" }}>
          <td
            style={{ fontSize: "14px", width: "300px", paddingTop: "20px" }}
            valign="top"
          >
            <strong>9.&nbsp; Installation:</strong>
          </td>
          <td style={{ paddingTop: "20px" }}>
            <p style={{ fontSize: "14px" }}>
              Free-of-cost. The required computer hardware & peripherals &
              Commissioning as advised by us must be readily available in
              working condition at the customer-site to carry out installation &
              commissioning
            </p>
          </td>
        </tr>
        <tr style={{ paddingTop: "20px" }}>
          <td
            style={{ fontSize: "14px", width: "300px", paddingTop: "20px" }}
            valign="top"
          >
            <strong>10.&nbsp; Training:</strong>
          </td>
          <td style={{ paddingTop: "20px" }}>
            <p style={{ fontSize: "14px" }}>
              Online Training covering the basic function of the supplied
              product will be provided free-of-cost. Advance training if
              required will be provided at extra cost.
            </p>
          </td>
        </tr>
        <tr style={{ paddingTop: "20px" }}>
          <td
            style={{ fontSize: "14px", width: "300px", paddingTop: "20px" }}
            valign="top"
          >
            <strong>11.&nbsp; Warranty:</strong>
          </td>
          <td style={{ paddingTop: "20px" }}>
            <p style={{ fontSize: "14px" }}>
              Hardware: 1 Year from the date of Purchase.<br></br>
              Software: 90 days from the date of Software.
            </p>
          </td>
        </tr>
        <tr style={{ paddingTop: "20px" }}>
          <td
            style={{ fontSize: "14px", width: "300px", paddingTop: "20px" }}
            valign="top"
          >
            <strong>12.&nbsp; Annual Maintenance:</strong>
          </td>
          <td style={{ paddingTop: "20px" }}>
            <p style={{ fontSize: "14px" }}>
              Hardware: Second year onwards, @ 18% of the prevailing cost of the
              pertinent product. Service Tax extra <br></br>
              Software: Second Year onwards, @ 20% of the prevailing cost of the
              pertinent product. Service Tax extra
            </p>
          </td>
        </tr>
        <tr style={{ paddingTop: "20px" }}>
          <td
            style={{ fontSize: "14px", width: "300px", paddingTop: "20px" }}
            valign="top"
          >
            <strong>13.&nbsp; Deliverables:</strong>
          </td>
          <td style={{ paddingTop: "20px" }}>
            <p style={{ fontSize: "14px" }}>
              Hardware Items: As packaged by Original Equip Manufacturer
              <br></br>
              Software Items: Web link for online download
            </p>
          </td>
        </tr>
      </tbody>
    </table>
  );
}
